// assets/bundle-add.js

(function () {
  if (window.__bundleAddInitialized) {
    console.log("[bundle-add] already initialized, skipping");
    return;
  }
  window.__bundleAddInitialized = true;

  const DEBUG = false;

  function log(...args) {
    if (DEBUG) console.log("[bundle-add]", ...args);
  }

  function parseVariantIds(raw) {
    if (!raw) return [];
    return String(raw)
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean)
      .filter((s) => /^\d+$/.test(s))
      .map((s) => Number(s));
  }

  function getQuantityFromForm(formEl) {
    const qtyInput = formEl.querySelector('input[name="quantity"]');
    const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  async function addItems(items) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items }),
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`cart/add.js failed (${res.status}): ${text}`);
    }
    return res.json();
  }

  function isNonEmpty(str) {
    return String(str || "").trim().length > 0;
  }

  // Optional: try to refresh/open Horizon cart UI without redirecting
  async function refreshCartUI() {
    // Many themes listen for these
    window.dispatchEvent(new CustomEvent("cart:refresh"));
    window.dispatchEvent(new CustomEvent("cart:updated"));

    // Also update sections via /cart.js fetch (doesn't redirect)
    try {
      await fetch("/cart.js", { headers: { Accept: "application/json" } });
    } catch (_) {}
  }

  async function handleSubmit(e) {
    const form = e.target;
    if (!form || form.tagName !== "FORM") return;

    // Only intercept Shopify add-to-cart forms
    const action = (form.getAttribute("action") || "").toLowerCase();
    if (!action.includes("/cart/add")) return;

    // Find bundle button inside THIS form
    const bundleBtn = form.querySelector("button[data-bundle-child-variant-ids]");
    if (!bundleBtn) return;

    const childRaw = bundleBtn.getAttribute("data-bundle-child-variant-ids");
    if (!isNonEmpty(childRaw)) return; // not a bundle

    const parentIdRaw = bundleBtn.getAttribute("data-bundle-parent-variant-id");
    const parentId = /^\d+$/.test(String(parentIdRaw || "")) ? Number(parentIdRaw) : null;
    const childIds = parseVariantIds(childRaw);

    log("bundle detected", { parentId, childIds });

    if (!parentId || childIds.length === 0) {
      console.warn("[bundle-add] Missing/invalid parentId or empty childIds. Not intercepting.");
      return;
    }

    // ✅ Prevent normal theme add-to-cart + redirect + duplicates
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

    // ✅ Extra guard: if something somehow triggers submit twice fast, ignore
    if (form.__bundleAddInFlight) {
      log("in-flight, ignoring duplicate submit");
      return;
    }
    form.__bundleAddInFlight = true;

    // Disable button while adding (prevents double clicks)
    const wasDisabled = bundleBtn.disabled;
    bundleBtn.disabled = true;

    const qty = getQuantityFromForm(form);
    const bundleKey = `b_${Date.now()}_${Math.random().toString(16).slice(2)}`;

    const items = [
      {
        id: parentId,
        quantity: qty,
        // NOTE: nesting is driven by parent_id in the items array (per your working example)
        properties: {
          _bundle_key: bundleKey,
          _bundle_role: "parent",
          _bundle_children: childIds.join(","),
        },
      },
      ...childIds.map((id) => ({
        id,
        quantity: qty,
        parent_id: parentId, // ✅ NESTING
        properties: {
          _bundle_key: bundleKey,
          _bundle_role: "child",
          _bundle_parent: String(parentId),
        },
      })),
    ];

    log("adding items", items);

    try {
      await addItems(items);
      log("added successfully");

      // ✅ NO redirect. Stay on PDP.
      await refreshCartUI();
    } catch (err) {
      console.error("[bundle-add] Error adding bundle items:", err);
      alert("Sorry—there was an issue adding the bundle to cart. Check console for details.");
    } finally {
      form.__bundleAddInFlight = false;
      bundleBtn.disabled = wasDisabled;
    }
  }

  function init() {
    // Capture submit events so we intercept before theme handlers
    document.addEventListener("submit", handleSubmit, true);
    log("loaded: submit listener active");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
